import { ConfigurationValues } from '@cutr/constants/windows/windows';
import {
  ConfigurationKey,
  ConfigurationsOptions,
  CustomRequestsOptions,
} from '@cutr/constants/windows/windows-configurations.ts';

import aluCladdingColor from './AluCladdingColorConfig';
import coverStrips from './CoverStripsConfig';
import customRequest from './CustomRequestConfig';
import frameBeamWidth from './FrameBeamWidthConfig';
import glassType from './GlassTypeConfig';
import handle from './HandleConfig';
import hardware from './HardwareConfig';
import paintColorInside from './PaintColorInsideConfig';
import paintColorOutside from './PaintColorOutsideConfig';
import plasteringStrips from './PlasteringStripsConfig';
import rainGuardColor from './RainGuardConfig';
import sashbars from './SashbarsConfig';
import sashBeamWidth from './SashBeamWidthConfig';
import sashCoverColor from './SashCoverConfig';
import sealantInnerColor from './SealantInnerColorConfig';
import sealantOuterColor from './SealantOuterColorConfig';
import sealOptions from './SealOptionsConfig';
import system from './SystemConfig';
import thickness from './ThicknessConfig';
import weatherRail from './WeatherRailConfig';
import windowSillDecorativeProfile from './WindowSillDecorativeProfileConfig';
import windowSills from './WindowSillsConfig';
import woodType from './WoodTypeConfig';

export type ConfigurationComponent<
  K extends ConfigurationKey = ConfigurationKey,
> = {
  key: K;
  input: React.ReactNode;
  display: (value: ConfigurationValues[K]) => React.ReactNode;
};

// Create a mapped type that ensures each key has the correct specific type
type ConfigurationComponents = {
  [K in keyof ConfigurationsOptions]: ConfigurationComponent<K>;
};

export const configurationsRegistry: ConfigurationComponents = {
  // Standard configurations
  thickness,
  system,
  woodType,
  glassType,
  paintColorInside,
  paintColorOutside,
  aluCladdingColor,
  sealantInnerColor,
  sealantOuterColor,
  sealOptions,
  handle,
  hardware,

  // Geometry configurations
  windowSills,
  windowSillDecorativeProfile,
  frameBeamWidth,
  sashBeamWidth,

  // Covers configurations
  rainGuardColor,
  sashCoverColor,
  weatherRail,

  // Fitting configurations
  coverStrips,
  plasteringStrips,

  // Decorative configurations
  sashbars,
};

export type CustomRequestConfigurationComponent<
  K extends keyof CustomRequestsOptions = keyof CustomRequestsOptions,
> = {
  key: K;
  input: React.ReactNode;
  display: (value: CustomRequestsOptions[K]) => React.ReactNode;
};

// Create a mapped type that ensures each key has the correct specific type
type CustomRequestConfigurationComponents = {
  [K in keyof CustomRequestsOptions]: CustomRequestConfigurationComponent<K>;
};

export const customRequestConfigurationRegistry: CustomRequestConfigurationComponents =
  {
    customRequest,
  };
